// extracted by mini-css-extract-plugin
module.exports = {"text_input":"Input_text_input__1wkiL"};